import React from "react";
import { useContext, useEffect } from "react";
import styled from "styled-components";
import { Button, ScrollBar } from "../../Theme/Hyper";
import { APIContext } from "../../contexts/APIContext";
import SelectUI from "../UI/Form/SelectUI";
import { useState } from "react";
import RightSideBar from "./RightSideBar";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { GraphicsContext } from "../../contexts/GraphicsContext";
const Main = styled.div`
  display: flex;
  width: 100vw;
`;
const Row = styled.div`
  display: flex;
`;
const Teams = styled(ScrollBar)`
  display: flex;
  flex-direction: column;
  margin: 5px;
  max-height: 90vh;
  overflow-y: scroll;
  width: 250px;
`;
const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
`;
const Team = styled.div`
  display: flex;
  min-height: 39px;
  background-color: ${(props) => (props.selected ? "#0adb93" : "#202731")};
  color: ${(props) => (props.selected ? "#000" : "")};
  border-bottom: 2px solid #181d25;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
  padding-left: 5px;
  min-width: 200px;
  opacity: ${(props) => (props.fade ? "0.5" : "1")};

  :hover {
    background-color: #0adb93;
  }
`;
const Select = styled.div`
  display: flex;
  width: 200px;
  margin-right: 10px;
`;

const Group = styled.div`
  display: flex;
  background-color: #202731;
  border-radius: 4px;
  min-width: 200px;
  height: 200px;
  margin: 5px;
  flex-direction: column;
`;

const GroupTeams = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Title = styled.div`
  padding: 10px;
`;

const Subtitle = styled.div`
  padding: 1em;
  margin-bottom: 1em;
  width: 100px;
`;
const RightBar = styled.div`
  display: flex;
  width: 300px;
  box-shadow: -3px 1px 3px 0 rgb(0 0 0 / 42%);
  height: 100vh;
`;
const Content = styled.div`
  display: flex;
  margin-left: 1em;

  margin-top: 1em;
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
`;

const TableGroup = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  
`;

function DrawFixtures() {
  const { getCompetition, getSeason } = useContext(APIContext);
  const [competitions, setCompetitions] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [showCustomTeam, setShowCustomTeam] = useState(false);
  const [selectedCompetition, setSelectedCompetition] = useLocalStorage(
    "draw_comp",
    []
  );
  const [selectedSeason, setSelectedSeason] = useLocalStorage(
    "draw_season",
    []
  );
  const [selectedSlot, setSelectedSlot] = useState();
  const [newCustomTeam, setNewCustomTeam] = useState();
  const [groups, setGroups] = useLocalStorage("draw_groups", []);
  const [logoVisible, setLogoVisible] = useLocalStorage("draw_logo", [{ value: true, label: "Show Logo" }]);
  const [customTeams, setCustomTeams] = useLocalStorage("draw_custom", []);
  const [topline, setTopline] = useLocalStorage("draw_topline", "GAA ALL-IRELAND FOOTBALL SENIOR CHAMPIONSHIP");
  const [bottomline, setBottomline] = useLocalStorage("draw_bottomline", "FIXTURES TO BE PLAYED 23/24 & 30/31 MAY");
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);

  useEffect(() => {
    getCompetition()?.then((data) => {
      setCompetitions([...(data || [])]);
    });
  }, []);

  useEffect(() => {
    getSeason()?.then((data) => {
      setSeasons(
        data?.filter((s) => s.competition?._id === selectedCompetition?._id)
      );
    });
  }, [selectedCompetition]);

  useEffect(() => {
    updateGraphic("Draw", { groups, topline, bottomline, logoVisible });
  }, [groups, topline, bottomline, logoVisible]);

  return (
    <Main>
      <Row
        style={{
          width: "100%",
        }}
      >
      <Content
        style={{
          maxWidth: "500px",
          width: "20%",
        }}
      >
        <Row>
          <Select>
            <SelectUI
              value={
                selectedCompetition
                  ? {
                      value: selectedCompetition,
                      label: selectedCompetition?.name,
                    }
                  : ""
              }
              options={competitions
                ?.sort((a, b) => {
                  return (a.order || 999) - (b.order || 999);
                })
                ?.map((c) => {
                  return {
                    value: c,
                    label: c?.name,
                  };
                })}
              placeholder="Select Competition"
              onChange={(comp) => {
                setSelectedCompetition(comp);
              }}
            />
          </Select>
          <Select>
            <SelectUI
              value={
                selectedSeason
                  ? {
                      value: selectedSeason,
                      label: selectedSeason?.name,
                    }
                  : ""
              }
              options={seasons
                .sort((a, b) => {
                  return (a.order || 999) - (b.order || 999);
                })
                .map((c) => {
                  return {
                    value: c,
                    label: c?.name,
                  };
                })}
              placeholder="Select Season"
              onChange={(season) => {
                setSelectedSeason(season);
              }}
            />
          </Select>
        </Row>
        <Row>
          <Teams>
            {JSON.parse(JSON.stringify(selectedSeason?.teams || []))
              ?.sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              })
              ?.slice(0, selectedSeason?.teams?.length / 2)
              ?.map((team) => {
                return (
                  <Team
                    fade={
                      groups?.findIndex((t) => t.team?._id === team?._id) > -1
                    }
                    onClick={() => {
                      if (selectedSlot) {
                        let new_groups = [...groups];
                        new_groups = new_groups.filter(
                          (t) => t.group !== selectedSlot
                        );
                        new_groups.push({ team: team, group: selectedSlot });
                        setGroups(new_groups);
                      }
                    }}
                  >
                    {team?.name}
                  </Team>
                );
              })}
          </Teams>
          <Teams>
            {JSON.parse(JSON.stringify(selectedSeason?.teams || []))
              ?.sort((a, b) => {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              })
              ?.slice(
                selectedSeason?.teams?.length / 2,
                selectedSeason?.teams?.length
              )
              ?.map((team) => {
                return (
                  <Team
                    fade={
                      groups?.findIndex((t) => t.team?._id === team?._id) > -1
                    }
                    onClick={() => {
                      if (selectedSlot) {
                        let new_groups = [...groups];
                        new_groups = new_groups.filter(
                          (t) => t.group !== selectedSlot
                        );
                        new_groups.push({ team: team, group: selectedSlot });
                        setGroups(new_groups);
                      }
                    }}
                  >
                    {team?.name}
                  </Team>
                );
              })}
          </Teams>
        </Row>
         <Row>Custom</Row>
        <Row>
          <Teams>
            {customTeams?.map((team) => {
              return (
                <Team
                  fade={
                    groups?.findIndex((t) => t.team?._id === team?._id) > -1
                  }
                  onClick={() => {
                    if (selectedSlot) {
                      let new_groups = [...groups];
                      new_groups = new_groups.filter(
                        (t) => t.group !== selectedSlot
                      );
                      new_groups.push({ team: team, group: selectedSlot });
                      setGroups(new_groups);
                    }
                  }}
                >
                  {team?.name}
                </Team>
              );
            })}
          </Teams>
        </Row>
        <Row style={{ marginTop: "40px" }}>
          <Input
            placeholder="Custom team name"
            value={newCustomTeam}
            onChange={(e) => {
              setNewCustomTeam(e.currentTarget.value);
            }}
          />
          <Button
            style={{ marginLeft: "20px" }}
            onClick={() => {
              let new_teams = [...customTeams];
              new_teams.push({
                _id: Date.now() + "_" + newCustomTeam,
                name: newCustomTeam,
              });
              setCustomTeams(new_teams);
              setNewCustomTeam("");
            }}
          >
            + Add Team
          </Button>
        </Row>
        <Row style={{ marginTop: "100px" }}>
          <Button
            red
            onClick={() => {
              setGroups([]);
            }}
          >
            RESET DATA
          </Button>
          <Button
            style={{ marginLeft: "40px" }}
            red
            onClick={() => {
              setCustomTeams([]);
            }}
          >
            CLEAR CUSTOM TEAMS
          </Button>
        </Row>
        </Content>
          <Content
                  style={{
          width: "75%",
        }}>
            <TableGroup>
          <Group>
            <Title>Game 1</Title>
            <GroupTeams>
              <GroupItem
                slot="group_1_slot_1"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_1_slot_2"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 2</Title>
            <GroupTeams>
              <GroupItem
                slot="group_1_slot_3"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_1_slot_4"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 3</Title>
            <GroupTeams>
              <GroupItem
                slot="group_2_slot_1"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_2_slot_2"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 4</Title>
            <GroupTeams>
              <GroupItem
                slot="group_2_slot_3"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_2_slot_4"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 5</Title>
            <GroupTeams>
              <GroupItem
                slot="group_3_slot_1"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_3_slot_2"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 6</Title>
            <GroupTeams>
              <GroupItem
                slot="group_3_slot_3"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_3_slot_4"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 7</Title>
            <GroupTeams>
              <GroupItem
                slot="group_4_slot_1"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_4_slot_2"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
          <Group>
            <Title>Game 8</Title>
            <GroupTeams>
              <GroupItem
                slot="group_4_slot_3"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
              <GroupItem
                slot="group_4_slot_4"
                groups={groups}
                setGroups={setGroups}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
              />
            </GroupTeams>
          </Group>
        </TableGroup>
        <Title>Lower Third Options</Title>
        <Row style={{alignItems: "center", marginTop: "20px"}}>
          <Subtitle>Top Line:</Subtitle>
          <Input
          style={{width:"400px"}}
            placeholder="Top Line"
            value={topline}
            onChange={(e) => {
              setTopline(e.currentTarget.value);
            }}
          />
          </Row>
          <Row style={{alignItems: "center"}}>
          <Subtitle>Bottom Line:</Subtitle>
          <Input
            style={{width:"400px"}}
            placeholder="Bottom Line"
            value={bottomline}
            onChange={(e) => {
              setBottomline(e.currentTarget.value);
            }}
          />
        </Row>
        <Row style={{alignItems: "center"}}>
          <Subtitle>Logo:</Subtitle>
          <Select>
          <SelectUI
          options={[{
            value: "true",
            label: "Show Logo"
          },{
            value: "false",
            label: "Hide Logo"
          }]}
          label={logoVisible}
          onChange={(e) => {
            setLogoVisible(e);
          }}/>
          </Select>
        </Row>
       
      </Content>
      </Row>
      <RightBar>
        <RightSideBar
          groups={groups}
          competition={selectedCompetition}
          logoVisible={logoVisible}
          topline={topline}
          bottomline={bottomline}
          selectedSeason={selectedSeason}
          previewGraphic={previewGraphic}
          graphicInPreview={graphicInPreview}
          animateGraphic={animateGraphic}
          animateOffGraphic={animateOffGraphic}
          updateGraphic={updateGraphic}
          clearPreview={clearPVW}
        />
      </RightBar>
    </Main>
  );
}

function GroupItem({ slot, groups, selectedSlot, setSelectedSlot, setGroups }) {
  return (
    <Team
      fade={!groups?.find((g) => g.group === slot)}
      selected={selectedSlot === slot}
      onClick={() => {
        setSelectedSlot(slot);
      }}
    >
      {groups?.find((g) => g.group === slot)?.team?.name ||
        "Team Name"}
      {groups?.find((g) => g.group === slot) && selectedSlot === slot && (
        <Button
          style={{ marginLeft: "auto", marginRight: "5px" }}
          red
          onClick={() => {
            setGroups(groups?.filter((g) => g.group !== slot));
          }}
        >
          Remove
        </Button>
      )}
    </Team>
  );
}
export default DrawFixtures;
